import {
    mdiAlertOutline,
    mdiCancel,
    mdiCheckCircleOutline,
    mdiCircleOutline,
    mdiClockOutline,
    mdiCloseCircleOutline,
    mdiPencilOutline,
    mdiPlayCircleOutline,
    mdiProgressClock,
} from '@mdi/js'

type Tone = 'outline' | 'info' | 'success' | 'warning' | 'destructive' | 'secondary'

/**
 * One map per status family (patterns §15, status pill): the tone, the icon
 * and the i18n key of each value, in display order.
 */
export const CAMPAIGN_STATUS: Record<string, { tone: Tone; icon: string }> = {
    draft: { tone: 'outline', icon: mdiPencilOutline },
    launched: { tone: 'info', icon: mdiPlayCircleOutline },
    closed: { tone: 'success', icon: mdiCheckCircleOutline },
}

export const UNIT_STATUS: Record<string, { tone: Tone; icon: string }> = {
    todo: { tone: 'outline', icon: mdiCircleOutline },
    in_progress: { tone: 'warning', icon: mdiProgressClock },
    done: { tone: 'success', icon: mdiCheckCircleOutline },
}

export const APPLY_STATUS: Record<string, { tone: Tone; icon: string }> = {
    pending: { tone: 'outline', icon: mdiClockOutline },
    applied: { tone: 'success', icon: mdiCheckCircleOutline },
    rejected: { tone: 'secondary', icon: mdiCancel },
    conflict: { tone: 'warning', icon: mdiAlertOutline },
    failed: { tone: 'destructive', icon: mdiCloseCircleOutline },
}
